export const SUPPORTED_LANGUAGES = ["ko", "en", "zh-CN", "zh-TW"] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export function isLanguage(value: unknown): value is Language {
  return (
    typeof value === "string" &&
    SUPPORTED_LANGUAGES.includes(value as Language)
  );
}

export const LANGUAGE_LABELS: Record<
  Language,
  { native: string; korean: string }
> = {
  ko: { native: "한국어", korean: "한국어" },
  en: { native: "English", korean: "영어" },
  "zh-CN": { native: "简体中文", korean: "중국어 간체" },
  "zh-TW": { native: "繁體中文", korean: "중국어 번체" },
};

export function intlLocale(language: Language) {
  return language === "ko" ? "ko-KR" : language;
}
